import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ListChecks, LoaderCircle } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const RenewalChecklistButton = ({ className = "" }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const generate = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const { data } = await api.post("/titre/checklist");
      toast.success(data.added > 0
        ? `${data.added} pièce(s) à préparer ajoutée(s) à votre checklist « Mes documents ».`
        : "Votre checklist de renouvellement est déjà à jour dans « Mes documents ».");
      navigate("/dashboard/documents");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Impossible de générer la checklist. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button type="button" onClick={generate} disabled={loading}
      className={`btn-primary !px-5 !py-2.5 !text-xs disabled:opacity-50 ${className}`}
      data-testid="renewal-checklist-button">
      {loading ? <><LoaderCircle className="h-3.5 w-3.5 animate-spin" /> Génération…</>
        : <><ListChecks className="h-3.5 w-3.5" /> Préparer mon renouvellement</>}
    </button>
  );
};
